import { ulid } from 'ulid';

export interface WarehouseTransferCostJson {
    id?: number;
    ulid?: string;
    created_at?: string;
    updated_at?: string;
    name: string;
    comment: string | null;
    amount: string;
    currency: string;
    exchange_rate: string;
    base_currency: string | null;
    cost_type: 'per_unit' | 'per_transfer';
    scope: 'whole_transfer' | 'line_item';
    warehouse_transfer_id: number;
    warehouse_transfer_item_ulid?: string | null;
}

export default class WarehouseTransferCost {
    id: number = 0;
    ulid: string = ulid().toLowerCase();
    name: string = '';
    comment: string | null = null;
    amount: string = '0.00';
    currency: string = 'GBP';
    exchange_rate: string = '1.00000000';
    base_currency: string | null = null;
    cost_type: 'per_unit' | 'per_transfer' = 'per_transfer';
    scope: 'whole_transfer' | 'line_item' = 'whole_transfer';
    warehouse_transfer_id: number = 0;
    warehouse_transfer_item_ulid: string | null = null;

    toJSON(): WarehouseTransferCostJson {
        return {
            ulid: this.ulid,
            name: this.name,
            comment: this.comment,
            amount: this.amount,
            currency: this.currency,
            exchange_rate: this.exchange_rate,
            base_currency: this.base_currency,
            cost_type: this.cost_type,
            scope: this.scope,
            warehouse_transfer_id: this.warehouse_transfer_id,
            warehouse_transfer_item_ulid: this.warehouse_transfer_item_ulid,
        };
    }

    static fromJSON(json: WarehouseTransferCostJson): WarehouseTransferCost {
        const cost = Object.create(WarehouseTransferCost.prototype);
        return Object.assign(cost, json);
    }
}
